/**
 * Fast in-memory user search for admin pickers (thousands of users).
 *
 * buildUserIndex() runs once per user list: it lower-cases the searchable
 * text and sorts by recent activity a single time. searchUsers() then does a
 * plain substring scan that stops as soon as `limit` matches are found, so a
 * keystroke never sorts or allocates the whole list again.
 */

function toTime(value) {
  if (!value) return 0;
  if (typeof value === 'number') return value;
  const time = Date.parse(value);
  return Number.isNaN(time) ? 0 : time;
}

export function buildUserIndex(users = []) {
  return users
    .map((user) => ({
      user,
      haystack: [user.email, user.displayName, user.name, user.userId].filter(Boolean).join(' ').toLowerCase(),
      recency: Math.max(toTime(user.lastSignInTime), toTime(user.lastLoginAt), toTime(user.creationTime), toTime(user.createdAt)),
    }))
    .sort((a, b) => b.recency - a.recency);
}

export function searchUsers(index, query, limit = 20) {
  const q = String(query || '').trim().toLowerCase();
  if (!q) return index.slice(0, limit).map((entry) => entry.user);

  // Exact email / id matches first, then prefix matches, then substring matches.
  const exact = [];
  const prefix = [];
  const contains = [];
  for (let i = 0; i < index.length; i += 1) {
    const entry = index[i];
    const position = entry.haystack.indexOf(q);
    if (position === -1) continue;
    const { email, userId } = entry.user;
    if ((email && email.toLowerCase() === q) || userId === query.trim()) exact.push(entry.user);
    else if (position === 0 || entry.haystack.charAt(position - 1) === ' ') prefix.push(entry.user);
    else contains.push(entry.user);
    if (exact.length + prefix.length >= limit) break;
  }
  return [...exact, ...prefix, ...contains].slice(0, limit);
}
